import type { SVGProps } from "react";
// generated from Order.svg — do not edit manually
// prettier-ignore
export default function Order(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path opacity="0.3" d="M 17 15 L 12 20 L 7 15" stroke="currentColor" strokeWidth="1.5"/><path opacity="0.3" d="M 17 9 L 12 4 L 7 9" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
